import { useAccountState } from 'contexts/account/account-context';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { isNullOrUndefined } from 'utils/empty-or-null';
import { BluViuNutritionParams } from '../types/bluviu-nutrition-params.type';

export const useSelectedSite = () => {
  const {
    account: { company },
  } = useAccountState();

  const params = useParams<BluViuNutritionParams>();

  const selectedSite = useMemo(() => {
    return company?.addressAccess?.find((site) => site.id === params.globalSiteId);
  }, [params, company]);

  const selectedSiteId = useMemo(() => {
    if (isNullOrUndefined(params.globalSiteId)) return '';
    else return params.globalSiteId;
  }, [params]);

  return { selectedSiteId, selectedSite };
};
